module.exports = __webpack_public_path__ + "media/arctic_circle.cdd8f927.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/resources/vector/grid/arctic_circle.geojson
// module id = 1114
// module chunks = 0